import { getWithRedirect, postWithRedirect } from 'utils/axios'

import type {
  TCreatedRerunDto,
  TCreateRerunRequest,
  TCreateRerunRequestBody,
  TDataRerunDetailDto,
  TDataRerunSummaryDto,
  TRerunCandidatesDto
} from '@homepal/api-contract'

const BASE_URL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3990/'
    : process.env.REACT_APP_HOMEPAL_MDM_API_PROD

const DATA_RERUNS_URL = `${BASE_URL}v1/internal/data-reruns`

/** Customers a rerun can be ordered for, all of them or just one. */
export async function getRerunCandidates(customerId?: string) {
  const url = customerId
    ? `${DATA_RERUNS_URL}/candidates?customer_id=${encodeURIComponent(
      customerId
    )}`
    : `${DATA_RERUNS_URL}/candidates`

  return getWithRedirect<TRerunCandidatesDto>(url)
}

export async function createRerun(body: TCreateRerunRequestBody) {
  const request: TCreateRerunRequest = { data: body }

  return postWithRedirect<TCreatedRerunDto>(DATA_RERUNS_URL, request)
}

/** The latest reruns, newest first, or only the unfinished ones. */
export async function getReruns(activeOnly: boolean) {
  const url = activeOnly ? `${DATA_RERUNS_URL}?active=true` : DATA_RERUNS_URL

  return getWithRedirect<TDataRerunSummaryDto[]>(url)
}

export async function getRerun(id: string) {
  return getWithRedirect<TDataRerunDetailDto>(
    `${DATA_RERUNS_URL}/${encodeURIComponent(id)}`
  )
}

/** Starts no more customers; the running ones finish. */
export async function cancelRerun(id: string) {
  return postWithRedirect<TDataRerunSummaryDto>(
    `${DATA_RERUNS_URL}/${encodeURIComponent(id)}/cancel`,
    {}
  )
}

/** Orders a new rerun of the customers that failed in a finished one. */
export async function retryFailedRerun(id: string) {
  return postWithRedirect<TCreatedRerunDto>(
    `${DATA_RERUNS_URL}/${encodeURIComponent(id)}/retry-failed`,
    {}
  )
}
